export const ACTIVITY_TYPES = [
  { value: 'Task', color: '#7b1fa2' },
  { value: 'Meeting', color: '#ed6c02' },
  { value: 'Lunch', color: '#8d6e63' },
  { value: 'Travel', color: '#43a047' },
  { value: 'Training', color: '#00897b' },
  { value: 'Other', color: '#546e7a' },
];

export const ACTIVITY_TYPE_COLORS = ACTIVITY_TYPES.reduce((acc, t) => {
  acc[t.value] = t.color;
  return acc;
}, {});

export const MOCK_PROJECTS = [
  { id: 'proj-1', name: 'Improvement & Idea' },
  { id: 'proj-2', name: 'Internal Tooling' },
  { id: 'proj-3', name: 'External & Client Handling' },
  { id: 'proj-4', name: 'Other' },
];

// Tasks are independent of projects — an activity is either a Project or a Task, never both.
export const MOCK_TASKS = [
  { id: 'task-1', name: 'Business Development' },
  { id: 'task-2', name: 'Technology or Development' },
  { id: 'task-3', name: 'Infrastructure Mgmt' },
  { id: 'task-4', name: 'Administration' },
  { id: 'task-5', name: 'Customer support & escalations' },
  { id: 'task-6', name: 'Marketing & Growth' },
  { id: 'task-7', name: 'Other' },
];
